// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"435":"6d965e0d","818":"6d965e0d","1979":"26243e9b","3476":"6d965e0d","6161":"6d965e0d","6827":"6d965e0d","8446":"6d965e0d"}[chunkId] + ".chunk.css";
};